import { WA_DEFAULT } from '@/lib/site'
import { WhatsAppIcon } from '@/components/Layout'

type CtaBandProps = {
  title?: string
  text?: string
}

export default function CtaBand({
  title = 'Pronto para comprar perfil no Instagram?',
  text = 'Fale com um especialista, informe o nicho e a faixa de seguidores. Enviamos opções reais, com métricas e transferência assistida.',
}: CtaBandProps) {
  return (
    <section className="relative overflow-hidden border-t border-white/10">
      <div className="absolute inset-0 ig-gradient opacity-90" />
      <div className="relative mx-auto flex max-w-6xl flex-col gap-6 px-4 py-14 sm:px-6 md:flex-row md:items-end md:justify-between">
        <div className="max-w-xl">
          <h2 className="font-display text-3xl text-white sm:text-4xl">{title}</h2>
          <p className="mt-3 text-sm leading-relaxed text-white/85">{text}</p>
        </div>
        <a
          href={WA_DEFAULT}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#070b14] px-5 py-3 text-sm font-semibold text-white"
        >
          <WhatsAppIcon className="h-4 w-4" />
          Falar com especialista no WhatsApp
        </a>
      </div>
    </section>
  )
}
